"use client";

import { c as _c } from "react/compiler-runtime";
import MarketplaceItemPreviewCard from "../MarketplaceItemPreviewCard";
import MarketplacePreviewPlaceholder from "./MarketplacePreviewPlaceholder";
import MarketplaceUnavailableCard from "./MarketplaceUnavailableCard";
import type { MarketplacePreviewMode, MarketplaceTypePreviewProps } from "./common";
import { useMarketplacePreviewState } from "./useMarketplacePreviewState";
interface MarketplacePreviewProps extends MarketplaceTypePreviewProps {
  readonly mode?: MarketplacePreviewMode | undefined;
}
export default function MarketplacePreview(t0) {
  const $ = _c(21);
  const {
    href,
    compact: t1,
    mode
  } = t0;
  const compact = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== href || $[1] !== mode) {
    t2 = {
      href,
      mode
    };
    $[0] = href;
    $[1] = mode;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const state = useMarketplacePreviewState(t2);
  if (state.href !== href || state.type === "loading") {
    let t3;
    if ($[3] !== compact || $[4] !== href) {
      t3 = <MarketplacePreviewPlaceholder href={href} compact={compact} />;
      $[3] = compact;
      $[4] = href;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    return t3;
  }
  if (state.type === "error") {
    let t3;
    if ($[6] !== compact || $[7] !== href) {
      t3 = <MarketplaceUnavailableCard href={href} compact={compact} />;
      $[6] = compact;
      $[7] = href;
      $[8] = t3;
    } else {
      t3 = $[8];
    }
    return t3;
  }
  const media = state.resolvedMedia;
  if (media) {
    let t3;
    if ($[9] !== compact || $[10] !== href || $[11] !== media.mimeType || $[12] !== media.url || $[13] !== state.resolvedDataHealth || $[14] !== state.resolvedPrice || $[15] !== state.resolvedPriceCurrency || $[16] !== state.resolvedTitle) {
      t3 = <MarketplaceItemPreviewCard href={href} mediaUrl={media.url} mediaMimeType={media.mimeType} price={state.resolvedPrice} priceCurrency={state.resolvedPriceCurrency} title={state.resolvedTitle} dataHealth={state.resolvedDataHealth} compact={compact} hideActions={compact} />;
      $[9] = compact;
      $[10] = href;
      $[11] = media.mimeType;
      $[12] = media.url;
      $[13] = state.resolvedDataHealth;
      $[14] = state.resolvedPrice;
      $[15] = state.resolvedPriceCurrency;
      $[16] = state.resolvedTitle;
      $[17] = t3;
    } else {
      t3 = $[17];
    }
    return t3;
  }
  let t3;
  if ($[18] !== compact || $[19] !== href) {
    t3 = <MarketplaceUnavailableCard href={href} compact={compact} />;
    $[18] = compact;
    $[19] = href;
    $[20] = t3;
  } else {
    t3 = $[20];
  }
  return t3;
}